<template>
  <el-header style="z-index: 999; position: fixed; top: 0; width: 100%; display: flex; padding: 0; height: 48px">
    <div class="sider-logo">{{ projectName }}</div>
    <div class="head-setting">
      <!--      左侧列表 如：首页>订单分类>订单分类详情  -->
      <div class="head-setting-left">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item
            v-for="(item, index) in breadcrumbList"
            :to="{ path: item.path }"
            :key="index"
            @click.native="breadcrumbClick(item)"
          >
            {{ item.name }}
          </el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <!--      头部左侧用户头像-->
      <div class="head-setting-right">
        <!-- 消息中心 小铃铛 -->
        <el-badge :is-dot="isRead" class="red-logo" v-if="$store.state.user.role !== 'supplier'">
          <i class="el-icon-message-solid" @click="$router.push('/message/list/')"></i>
        </el-badge>
        <el-avatar
          v-if="store.user.avatar"
          shape="circle"
          :size="30"
          :fit="'fill'"
          :src="`${$store.state.prefix}${store.user.avatar}`"
          class="head-setting-right-avatar"
        ></el-avatar>
        <el-avatar
          v-else
          shape="circle"
          :size="30"
          :fit="'fill'"
          class="head-setting-right-avatar"
        ></el-avatar>
        <el-dropdown @command="handleClick" v-if="$route.path !== '/login'">
          <span
            class="el-dropdown-link"
            style="font-size: 12px"
            v-if="store.user.role === 'manager' ||store.user.role === 'detection' || store.user.role === 'inspector'"
            >{{ store.user.realname }}</span
          >
          <span class="el-dropdown-link" style="font-size: 12px" v-else>{{ store.user.name }}</span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item icon="el-icon-edit" command="editBasicInfo">基本资料</el-dropdown-item>
            <el-dropdown-item icon="el-icon-edit" command="editPsd">修改密码</el-dropdown-item>
            <el-dropdown-item icon="el-icon-switch-button" command="logout">登出</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>

        <!-- 修改密码弹框 -->
        <el-dialog
          title="修改密码"
          :visible.sync="dialogVisible"
          :append-to-body="true"
          width="50%"
          :before-close="handleClose"
        >
          <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
            <el-form-item label="原密码" prop="originPass">
              <el-input type="password" v-model="ruleForm.originPass"></el-input>
            </el-form-item>
            <el-form-item label="新密码" prop="newPass">
              <el-input type="password" v-model="ruleForm.newPass"></el-input>
            </el-form-item>
            <el-form-item label="确认密码" prop="newPassConfirm">
              <el-input type="password" v-model="ruleForm.newPassConfirm"></el-input>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="handleClose">取消</el-button>
            <el-button type="primary" @click="handleConfirm('ruleForm')">确定</el-button>
          </div>
        </el-dialog>

        <!-- 基本资料弹窗 -->
        <el-dialog
          title="基本资料"
          :visible.sync="basicInfoDialog"
          :append-to-body="true"
          width="50%"
          :before-close="handleClose"
        >
          <el-form
            :model="basicRuleForm"
            :rules="basicRules"
            ref="basicRuleForm"
            label-width="100px"
            class="demo-ruleForm"
          >
            <el-form-item label="账号" prop="username" v-if="this.$store.state.user.role === 'manager'">
              <el-input v-model="basicRuleForm.username"></el-input>
            </el-form-item>
            <!-- <el-form-item
              label="姓名"
              prop="name"
              v-if="this.basicRuleForm.role === 'supplier' || this.basicRuleForm.role === 'warehouse'"
            >
              <el-input v-model="basicRuleForm.name"></el-input>
            </el-form-item> -->
            <el-form-item label="姓名" prop="realname" v-if="this.$store.state.user.role === 'manager'">
              <el-input v-model="basicRuleForm.realname"></el-input>
            </el-form-item>
            <el-form-item label="头像" prop="avatar">
<!--              <upload-->
<!--                @on-transport-file-list="handleTransportFileList"-->
<!--                :max-size="5120"-->
<!--                :limit="1"-->
<!--                :fileList="[$store.state.prefix + basicRuleForm.avatar]"-->
<!--                @handleSuccess="handleUploadSuccess"-->
<!--                @handleRemove="handleRemove"-->
<!--                ref="upload"-->
<!--                v-if="isFinished"-->
<!--              ></upload>-->
            </el-form-item>
            <el-form-item
              label="手机号"
              prop="contactPhone"
              v-if="this.basicRuleForm.role === 'supplier' || this.basicRuleForm.role === 'warehouse'"
            >
              <el-input v-model="basicRuleForm.contactPhone"></el-input>
            </el-form-item>
            <el-form-item label="手机号" prop="phone" v-else>
              <el-input v-model="basicRuleForm.phone"></el-input>
            </el-form-item>
            <el-form-item
              label="邮箱"
              prop="contactEmail"
              v-if="this.basicRuleForm.role === 'supplier' || this.basicRuleForm.role === 'warehouse'"
            >
              <el-input v-model="basicRuleForm.contactEmail"></el-input>
            </el-form-item>
            <el-form-item label="邮箱" prop="email" v-else>
              <el-input v-model="basicRuleForm.email"></el-input>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="handleClose">取消</el-button>
            <el-button type="primary" @click="handleBasicConfirm('basicRuleForm')">确定</el-button>
          </div>
        </el-dialog>
      </div>
    </div>
  </el-header>
</template>

<script>
// import Upload from '@/framework/components/upload'
// import { isUnread } from '@/project/service/message'
// import { updatePasswordByOldPasswordWithMe, update } from '@/project/service/manager'
export default {
  name: 'layout-header',
  components: {
    // Upload
  },
  data() {
    const validatePass = (rule, value, callback) => {
      if (value === '') {
        return callback(new Error('登录密码不能为空'))
      } else if (value.length < 6) {
        return callback(new Error('登录密码至少为6位'))
      } else {
        let i = 0
        ;/[A-Za-z]+/.test(value) && i++
        ;/\d+/.test(value) && i++
        ;/\.|\+|\-|\*|\/|\!|@|#|\$|%|\^|&|~|\\|\?+/.test(value) && i++
        if (i < 2) {
          return callback(new Error('大小写字母、数字、特殊字符任意两种组合'))
        }
        callback()
      }
    }
    var validateNewPassConfirm = (rule, value, callback) => {
      if (this.ruleForm.newPass !== this.ruleForm.newPassConfirm) {
        callback('密码不一致，请重新输入')
      } else if (this.ruleForm.newPassConfirm === '') {
        callback('请输入确认密码')
      } else {
        callback()
      }
    }
    // 手机号格式验证
    const phoneValidate = (rule, value, callback) => {
      if (!value) {
        callback('请输入')
      } else if (value !== '' && value.trim() !== '') {
        if (!/^1[3456789]\d{9}$/.test(value)) {
          callback('请输入正确手机号格式')
        } else {
          callback()
        }
      } else {
        callback()
      }
    }
    //   邮箱格式验证
    const emailValidate = (rule, value, callback) => {
      if (!value) {
        callback('请输入')
      } else if (value !== '' && value.trim() !== '') {
        if (!/^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/.test(value)) {
          callback('请输入正确的邮箱格式')
        } else {
          callback()
        }
      } else {
        callback()
      }
    }
    return {
      projectName: '采购防伪系统管理总后台',
      dialogVisible: false,
      rules: {
        originPass: [{ trigger: 'blur', required: 'true', message: '不能为空' }],
        newPass: [{ validator: validatePass, trigger: 'blur', required: 'true' }],
        newPassConfirm: [{ validator: validateNewPassConfirm, trigger: 'blur', required: 'true' }]
      },
      ruleForm: {
        originPass: '',
        newPass: '',
        newPassConfirm: ''
      },
      isRead: false,
      //  以下是基本资料涉及的参数
      basicRuleForm: {},
      basicRules: {
        username: [{ required: true, message: '请输入账号名', trigger: 'blur' }],
        realname: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
        name: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
        phone: [{ validator: phoneValidate, trigger: 'blur', required: true }],
        contactPhone: [{ validator: phoneValidate, trigger: 'blur', required: true }],
        email: [{ required: true, validator: emailValidate, trigger: 'blur' }],
        contactEmail: [{ required: true, validator: emailValidate, trigger: 'blur' }],
        avatar: [{ required: true, message: '请上传头像', trigger: 'change' }]
      },
      basicInfoDialog: false, //基本信息的弹窗
      fileList: [],
      user: {},
      isFinished: false,
      timeout: null
    }
  },
  computed: {
    breadcrumbList() {
      return this.$route.meta.breadcrumb
    },
    store() {
      return this.$store.state
    }
  },
  methods: {
    // 面包屑点击
    breadcrumbClick(item) {
      if (item.path === '/index') {
        this.$emit('breadcrumbClick')
      }
    },
    // 头像点击
    handleClick(val) {
      console.log('val',val)
      switch (val) {
        case 'editBasicInfo':
          this.editBasicInfo()
          break
        case 'editPsd':
          this.dialogVisible = true
          break
        case 'logout':
          let param = {}
          if (this.$store.state.user.role !== 'manager') {
            param.client = this.$store.state.user.role
          }
          this.$post(`api/${this.$store.state.user.role}/logout`, param, res => {
            this.$message.success('退出成功')
            // 清除定时器
            if (this.timeout) {
              clearInterval(this.timeout)
            }
            // 清除缓存
            localStorage.removeItem('userCache')
            localStorage.removeItem('IMinfo')
            localStorage.removeItem('token')
            localStorage.removeItem('currentChatId')
            sessionStorage.clear()
            this.$router.push({ path: '/login' })
          })
          break
      }
    },
    handleClose() {
      this.dialogVisible = false
      this.fileList = []
      this.basicInfoDialog = false
    },
    // 修改密码
    handleConfirm(formName) {
      this.$refs[formName].validate(valid => {
        if (!valid) return false
        if (this.$store.state.user.role === 'manager') {
          let param = {
            oldPassword: this.ruleForm.originPass,
            newPassword: this.ruleForm.newPass
          }
          updatePasswordByOldPasswordWithMe(param, res => {
            this.$message.success('修改成功，请重新登录')
            sessionStorage.clear()
            this.$router.push({ path: '/login' })
          })
        } else {
          this.$axios({
            method: 'post',
            url: `/api/${this.$store.state.user.role}/updatePasswordByOldPassword`,
            data: {
              oldPassword: this.ruleForm.originPass,
              password: this.ruleForm.newPass
            },
            headers: {
              'Access-Token': this.$store.state.token
            }
          }).then(res => {
            if (res.data.code !== 200) {
              if (res.data.code === 500 && res.data.message === '密码错误') {
                res.data.message = '原密码错误'
              }
              this.$notify.warning(res.data.message)
              this.ruleForm.originPass = ''
            } else {
              this.$message.success('修改成功，请重新登录')
              sessionStorage.clear()
              this.$router.push({ path: '/login' })
            }
          })
        }
      })
    },
    // 上传成功
    handleUploadSuccess(fileList) {
      if (fileList.length === 0) {
        return
      }
      // this.$refs.basicRuleForm.clearValidate('avatar')
      this.basicRuleForm.avatar = fileList[0].response.data
    },
    // 头像删除
    handleRemove() {
      this.basicRuleForm.avatar = ''
    },
    handleTransportFileList(fileList) {
      console.log('tansport'.fileList)
      this.fileList.concat(fileList)
      this.basicRuleForm.avatar = fileList[0].response.data
    },
    // 点击编辑基本资料
    editBasicInfo() {
      this.basicInfoDialog = true
      console.log('this', this.$store.state.user)
      this.isFinished = false
      this.basicRuleForm = JSON.parse(JSON.stringify(this.$store.state.user))
      console.log(' this.basicRuleForm', this.basicRuleForm, this.basicRuleForm.avatar)
      this.isFinished = true
    },
    updateSuccess() {
      this.$message.success('修改成功')
      this.$store.commit('SAVE_USER', this.basicRuleForm)
      // this.$store.dispatch('SAVE_USER_CACHE', this.basicRuleForm)
      this.basicInfoDialog = false
      this.$refs.upload.$refs.upload.clearFiles()
      this.isFinished = false
    },
    // 基本资料的确定
    handleBasicConfirm(formName) {
      this.$refs[formName].validate(valid => {
        if (!valid) return false
        console.log('this.basicRuleForm.role', this.basicRuleForm.role)
        if (this.$store.state.user.role === 'manager') {
          update({ [this.basicRuleForm.role]: this.basicRuleForm }, res => {
            this.updateSuccess()
          })
        } else {
          this.$axios({
            method: 'post',
            url: `/api/${this.basicRuleForm.role}/updateBaseInfo`,
            data: { [this.basicRuleForm.role]: this.basicRuleForm },
            headers: {
              'Access-Token': this.$store.state.token
            }
          }).then(res => {
            if (res.data.code === 200) {
              this.updateSuccess()
            } else {
              console.log('出错了')
              this.$notify.warning(res.data.message)
            }
          })
        }
      })
    }
  },
  created() {
    // if (this.$store.state.user.role !== 'supplier') {
    //   isUnread({}, res => {
    //     this.isRead = res
    //   })
    // }
    //在页面加载时读取sessionStorage里的状态信息
    // if (sessionStorage.getItem('store')) {
    //   this.$store.replaceState(Object.assign({}, this.$store.state, JSON.parse(sessionStorage.getItem('store'))))
    // }
    //在页面刷新时将vuex里的信息保存到sessionStorage里
    window.addEventListener('beforeunload', () => {
      sessionStorage.setItem('store', JSON.stringify(this.$store.state))
    })
  },
  mounted() {
    // 循环监听顶部 判断是否有未读消息
    // clearInterval(this.timeout)
    // if (this.$store.state.user.role !== 'supplier') {
    //   this.timeout = setInterval(() => {
    //     if (this.$route.path !== '/login' && this.$store.state.user.role !== 'supplier') {
    //       isUnread({}, res => {
    //         this.isRead = res
    //       })
    //     }
    //   }, 5000)
    // }
  }
}
</script>

<style lang="less" scoped>
.sider-logo {
  color: #57b382;
  background: rgb(20, 31, 41);
  width: 200px;
  font-size: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  font-weight: bold;
  font-family: 'Franklin Gothic Medium', 'Arial Narrow', Arial, sans-serif;
  &.en {
    font-size: 14px;
    text-align: center;
  }
}
.head-setting {
  display: flex;
  justify-content: space-between;
  width: 100%;
  align-items: center;
  box-shadow: 0 1px 2px 0 rgba(9, 18, 26, 0.06), 0 4px 8px 0 rgba(39, 56, 73, 0.08);
  padding: 0 20px;
  background: #fff;
  > span {
    font-size: 12px;
  }
  /deep/.el-input__inner {
    border: none;
    text-align: right;
  }
  /deep/.el-input {
    width: 100px;
  }
  .head-setting-right {
    height: 100%;
    display: flex;
    align-items: center;
    .red-logo {
      cursor: pointer;
      margin-top: 4px;
      margin-right: 20px;
    }
    .head-setting-right-avatar {
      margin-right: 10px;
    }
  }
}
.el-dropdown-menu {
  background: #ffffff;
  width: 123px;
  padding: 6px 0;
  font-size: 14px;
  margin: 0;
  border-radius: 0;
  &.en {
    width: 180px;
  }
  .el-dropdown-menu__item {
    color: #606266;
    &:hover {
      background: #f5f7fa;
      color: #606266;
    }
  }
  .popper__arrow {
    opacity: 1;
  }
}
.head-setting/deep/.el-select__caret {
  opacity: 0 !important;
}
.el-dropdown-link {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/framework/layout/layout-header.vue